<!--
 * @Author: zhaoliang
 * @Date: 2024-05-14 14:29:03
 * @LastEditTime: 2026-01-28 18:42:59
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/LoungePrebook/Modal/index.vue
 *
-->

<template>
  <teleport to="body">
    <div class="lounge-prebook-modal-mask" v-if="open">
      <div class="modal-containner">
        <h1 class="modal-title">{{ title }}</h1>

        <div class="modal-content">
          <slot name="content"></slot>
        </div>

        <div class="modal-footer">
          <button class="modal-ok-btn" @click="$emit('onOk')">
            {{ okText }}
          </button>
          <p class="modal-cancel-btn" @click="$emit('onCancel')">
            {{ cancelText }}
          </p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
  export default {
    name: 'Modal',
    emits: ['onOk', 'onCancel'],
    props: {
      title: {
        type: String,
        default: '',
      },
      open: {
        type: Boolean,
        default: false,
      },
      okText: {
        type: String,
        default: 'OK',
      },
      cancelText: {
        type: String,
        default: 'Cancel',
      },
    },
  };
</script>
<style lang="scss" scoped>
  .lounge-prebook-modal-mask {
    @include wh(100%, 100%);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(22, 48, 73, 0.94);

    .modal-containner {
      position: fixed;
      top: 20%;
      left: 50%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 46%;
      max-width: 720px;
      padding: 50px 72px 38px;
      background: #fff;
      border-radius: 10px;
      transform: translateX(-50%);

      .modal-title {
        @include font(40px, 700);
        margin-bottom: 24px;
        color: #163049;
      }

      .modal-content {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        @include font($size: 24px, $weight: 400);
        text-align: center;
        line-height: 30px;
        flex-direction: column;

        :deep(.password-input) {
          position: relative;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        :deep(input) {
          width: 80%;
          margin-top: 10px;
          padding: 10px;
          border: 1px solid #9eacb5;
          border-radius: 5px;
          box-sizing: border-box;
          line-height: 30px;

          &.error {
            border-color: #cc2222;
          }
        }

        :deep(.eye) {
          position: absolute;
          bottom: 11px;
          right: calc(10% + 10px);
          width: 30px;
          height: 30px;
        }

        :deep(.err-msg) {
          margin-top: 10px;
          @include font($size: 18px, $weight: 400);
          color: #cc2222;
        }
      }

      .modal-footer {
        margin-top: 24px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .modal-ok-btn {
          cursor: pointer;
          width: 80%;
          height: 64px;
          background-color: #c29d5c;
          color: #ffffff;
          @include font($size: 18px, $weight: 600);
          border-radius: 5px;
        }
        .modal-cancel-btn {
          margin-top: 24px;
          line-height: 1.5;
          @include font($size: 18px, $weight: 400);
          cursor: pointer;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .lounge-prebook-modal-mask {
      .modal-containner {
        width: 90%;
        padding: 30px 20px 30px;

        .modal-title {
          @include font(24px, 700);
          margin-bottom: 18px;
        }

        .modal-content {
          @include font($size: 12px, $weight: 400);
          line-height: 22px;

          :deep(input) {
            line-height: 22px;
          }

          :deep(.eye) {
            width: 22px;
            height: 22px;
          }
        }

        .modal-footer {
          margin-top: 18px;

          .modal-ok-btn {
            width: 80%;
            height: 48px;
            @include font($size: 14px, $weight: 600);
          }
          .modal-cancel-btn {
            margin-top: 18px;
            @include font($size: 14px, $weight: 400);
          }
        }
      }
    }
  }
</style>
